import { render, staticRenderFns } from "./NylasAuthRedirect.vue?vue&type=template&id=4646a274&scoped=true&"
import script from "./NylasAuthRedirect.vue?vue&type=script&lang=ts&"
export * from "./NylasAuthRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4646a274",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VContainer})
